import { useContext } from 'react';

import { XYChartSelectionAreaRefContext } from '../context/XYChartSelectionAreaRef.context.js';

export const useXYChartSelectionAreaRef = () => {
  const context = useContext(XYChartSelectionAreaRefContext);

  if (context === undefined) {
    throw new Error(
      'useXYChartSelectionAreaRef must be used within a XYChartSelectionAreaRef context',
    );
  }

  return context;
};
